import axios from "axios";
import serverHost from "./serverHost";
const TOKEN_KEY = "@PAINELESCOLA2023-PERTO-ACCESS-TOKEN";

export default {
  get(route, data) {
    return request("get", route, data);
  },
  post(route, data) {
    return request("post", route, data);
  },
  put(route, data) {
    return request("put", route, data);
  },
  delete(route, data) {
    return request("delete", route, data);
  },
};

const request = (method = "post", url, data) => {
  const api = axios.create({
    baseURL: serverHost(true),
    timeout: 90000,
  });

  return new Promise((resolve, reject) => {
    api({
      headers: { authorization: localStorage.getItem(TOKEN_KEY) },
      method,
      url,
      data,
      params: method === "get" ? data : undefined,
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
        console.log(err);

        if (!err.response) return;

        const { status } = err.response;

        if (status === 401) {
          localStorage.removeItem(TOKEN_KEY);
          return window.location.replace("/login?timeout=1");
        }

        if (status === 403) return window.location.replace("/naoAutorizado");

        reject(err);
      });
  });
};
